import { ReactComponent as Ticket } from "assets/icons/boleto.svg";
import { ReactComponent as Credit } from "assets/icons/credit.svg";
import { ReactComponent as Pix } from "assets/icons/Pix.svg";
import { useUi } from "context/ui/UIContext";
import { moneyMaskNumber } from "utils/mask/money";
import { PaymentTypeEnum } from "models/paymentLink/IPaymentLinkResponse";
import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { UsePaymentLink } from "./_UsePaymentLink";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Payment from "./components/payment/Payment";
import styles from "./PaymentLink.module.scss";
import { TextField } from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import { Apple, CalendarMonth } from "@mui/icons-material";
import { useDigitalWallet } from "./components/applePay/useApplePaySupport";
import { useParams } from "react-router-dom";
import { Error, WarningRounded } from "@material-ui/icons";
import { ICurrency } from "models/local/ILocalConfig";

export interface IPaymentLinkProps { }

const PaymentLink: FC<IPaymentLinkProps> = () => {
  const valueRef = useRef<HTMLInputElement>(null);
  const {
    paymentLink,
    handleChangeValue,
    handleBlurValue,
    inputMoneyMask,
    paymentLinkValue,
  } = UsePaymentLink(valueRef);
  const { isMobile } = useUi();
  const [imageSrc, setImageSrc] = useState<string>();
  const [logoSrc, setLogoSrc] = useState<string>();
  const isApplePaySupported = useDigitalWallet();

  const query = new URLSearchParams(window.location.search);
  const applePay = query.get("applePay") === "true";

  const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as ICurrency;

  const { enableCredit, enablePix, enableTicket, enableApplePay } = useMemo(
    () => ({
      enableCredit: paymentLink?.paymentTypes.find(
        (it) => it.type === PaymentTypeEnum.CREDIT
      ),
      enableTicket: paymentLink?.paymentTypes.find(
        (it) => it.type === PaymentTypeEnum.TICKET
      ),
      enablePix: paymentLink?.paymentTypes.find(
        (it) => it.type === PaymentTypeEnum.PIX
      ),
      enableApplePay: (
        paymentLink?.localId.toLocaleLowerCase() === "5147e4c7-db69-4063-a645-14b36f09ddab" ||
        paymentLink?.localId.toLocaleLowerCase() === "0209d91b-58f4-0bd3-6152-159290c2f466" ||
        applePay
      )
      //  (it) => it.type === PaymentTypeEnum.APPLE_PAY
      //),
    }),
    [paymentLink, applePay]
  );


  //const { enableCredit, enablePix, enableTicket, enableApplePay } = useMemo(
  //  () => ({
  //    enableCredit: true,
  //    enableTicket: true,
  //    enablePix: true,
  //    enableApplePay: true,
  //  }),
  //  []
  //);

  const [selectedPaymentType, setSelectedPaymentType] =
    useState<PaymentTypeEnum | null>(null);

  useEffect(() => {
    if (enableCredit) {
      setSelectedPaymentType(PaymentTypeEnum.CREDIT);
    } else if (enablePix) {
      setSelectedPaymentType(PaymentTypeEnum.PIX);
    } else if (enableTicket) {
      setSelectedPaymentType(PaymentTypeEnum.TICKET);
    }
  }, [enableCredit, enablePix, enableTicket]);

  const handleSelectType = useCallback((type: PaymentTypeEnum) => {
    setSelectedPaymentType(type);
  }, []);

  const disableButtons = useMemo(
    () =>
      paymentLink?.isVariable &&
      (!paymentLinkValue ||
        parseFloat(
          paymentLinkValue.replace(/[^\d]/g, "").replace(",", ".")
        ) < 1),
    [paymentLink, paymentLinkValue]
  );

  useEffect(() => {
    if (disableButtons) {
      setSelectedPaymentType(null);
    }
  }, [disableButtons]);

  const isValidImage = useCallback((url: string) => {
    const img = new Image();
    img.src = url;
    return new Promise((resolve) => {
      img.onerror = () => resolve(false);
      img.onload = () => resolve(true);
    });
  }, []);

  useEffect(() => {
    const loadImage = async () => {
      if (paymentLink?.id === undefined) return;

      const productImageUrl = `${process.env.REACT_APP_IMAGE_URL}mepay-link/${paymentLink?.id}.png`;
      const resultProductImage = await isValidImage(productImageUrl);
      if (resultProductImage) {
        setImageSrc(productImageUrl);
      }

      const logoUrl = `${process.env.REACT_APP_IMAGE_URL}clientes-profile/${paymentLink?.localId}.png`;
      const resultLogo = await isValidImage(logoUrl);
      if (resultLogo) {
        setLogoSrc(logoUrl);
      }
    };

    loadImage();
  }, [isValidImage, paymentLink]);

  //validar se expiracao maior que a data atual consisderando só o dia, mes e ano
  const IsExpirationDate = useMemo(() => {
    if (!paymentLink?.expirationDate) return false;
    const expirationDate = new Date(paymentLink.expirationDate).setHours(0, 0, 0, 0);
    //const expirationDate = new Date('2025-10-29T03:00:00.000').setHours(0, 0, 0, 0);
    const currentDate = new Date().setHours(0, 0, 0, 0);

    console.log("expirationDate", expirationDate);
    console.log("currentDate", currentDate);

    if (currentDate > expirationDate) return true;
    return false;
  }, [paymentLink]);

  return (
    <div id={styles.PaymentLink}>
      {paymentLink ? (
        <>
          <Header image={logoSrc} name={paymentLink.name} />
          <div
            className={styles.content}
            style={{
              flexDirection: isMobile ? "column" : "row",
              minHeight: isMobile ? undefined : 497,
            }}
          >
            <div
              className={styles.info}
              style={{
                width: isMobile ? 350 : undefined,
                gap: isMobile ? 6 : undefined,
              }}
            >
              {imageSrc && (
                <img
                  src={imageSrc}
                  alt="Foto_produto"
                  style={{
                    alignSelf: isMobile ? "center" : undefined,
                    marginBottom: isMobile ? 0 : undefined,
                    marginTop: isMobile ? 16 : undefined,
                  }}
                />
              )}
              <div className={styles.name}>{paymentLink?.product.nome}</div>
              <div className={styles.description}>
                {paymentLink?.description}
              </div>
              {paymentLink.isVariable ? (
                <div className={styles.variableValue}>
                  <label>
                    Insira o valor<span> *</span>
                  </label>
                  <TextField
                    inputRef={valueRef}
                    size="small"
                    placeholder={`${currency?.symbol ?? "R$"} 0,00`}
                    value={paymentLinkValue}
                    variant="outlined"
                    name={"value"}
                    onBlur={handleBlurValue}
                    onChange={handleChangeValue}
                  />
                </div>
              ) : (
                <div className={styles.value}>
                  {moneyMaskNumber(paymentLink.price)}
                </div>
              )}
              {IsExpirationDate && (
                <div className={styles.expirationDate}
                  style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}
                >
                  <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center" }}>
                    <WarningRounded style={{ color: "orange" }}
                      fontSize="large"
                      className={styles.warningIcon}
                    />
                    <h1
                      style={{ fontSize: "24px", fontWeight: "bold", color: "orange" }}
                    >Pagamento Indisponível</h1>
                  </div>
                  <p style={{ textAlign: "center" }}>
                    O link de pagamento expirou ou foi finalizado.
                  </p>
                </div>
              )}
              {!IsExpirationDate && (
                <div className={styles.paymentForm}>
                  <p>Forma de pagamento:</p>
                  <div>
                    {enableCredit && (
                      <Tooltip title={`Valor mínimo ${currency?.symbol ?? "R$"} 1,00`}>
                        <div
                          className={
                            selectedPaymentType === PaymentTypeEnum.CREDIT
                              ? styles.creditIconActive
                              : styles.creditIconInactive
                          }
                        >
                          <div
                            onClick={() =>
                              handleSelectType(PaymentTypeEnum.CREDIT)
                            }
                            className={
                              disableButtons || paymentLink.price < 1
                                ? styles.disabled
                                : ""
                            }
                            style={{ height: isMobile ? 106 : undefined }}
                          >
                            <Credit />
                            <p>Crédito</p>
                            {!paymentLink.isSinglePayment && <small className={styles.paymentInformation}>Recorrente</small>}
                          </div>
                        </div>
                      </Tooltip>
                    )}
                    {enablePix && (
                      <Tooltip title={`Valor mínimo ${currency?.symbol ?? "R$"} 1,00`}>
                        <div
                          className={
                            selectedPaymentType === PaymentTypeEnum.PIX
                              ? styles.pixIconActive
                              : styles.pixIconInactive
                          }
                        >
                          <div
                            onClick={() => handleSelectType(PaymentTypeEnum.PIX)}
                            className={
                              disableButtons || paymentLink.price < 1
                                ? styles.disabled
                                : ""
                            }
                            style={{ height: isMobile ? 106 : undefined }}
                          >
                            <Pix style={{ margin: 8 }} />
                            <p>PIX</p>
                          </div>
                        </div>
                      </Tooltip>
                    )}
                    {enableTicket && (
                      <Tooltip title={`Valor mínimo ${currency?.symbol ?? "R$"} 5,00`}>
                        <div
                          className={
                            selectedPaymentType === PaymentTypeEnum.TICKET
                              ? styles.ticketIconActive
                              : styles.ticketIconInactive
                          }
                        >
                          <div
                            onClick={() =>
                              handleSelectType(PaymentTypeEnum.TICKET)
                            }
                            className={
                              disableButtons || paymentLink.price < 5
                                ? styles.disabled
                                : ""
                            }
                            style={{ height: isMobile ? 106 : undefined }}
                          >
                            <Ticket />
                            <p>Boleto</p>
                          </div>
                        </div>
                      </Tooltip>
                    )}
                    {enableApplePay && isApplePaySupported === "apple" && (
                      <Tooltip title="Valor mínimo R$ 1,00">
                        <div
                          className={
                            selectedPaymentType === PaymentTypeEnum.APPLE_PAY
                              ? styles.ticketIconActive
                              : styles.ticketIconInactive
                          }
                        >
                          <div
                            onClick={() => handleSelectType(PaymentTypeEnum.APPLE_PAY)}
                            className={
                              disableButtons //|| paymentLink.price < 1
                                ? styles.disabled
                                : ""
                            }
                            style={{ justifyContent: "center", alignItems: "center", height: isMobile ? 106 : undefined }}
                          >
                            <Apple style={{ color: "white", width: 34, height: 34 }} />
                            <p>Apple Pay</p>
                          </div>
                        </div>
                      </Tooltip>
                    )}
                  </div>
                </div>
              )}
            </div>
            {!isMobile && <div className={styles.divisor} />}
            <>
              {!IsExpirationDate && (
                <Payment
                  selectedPaymentType={selectedPaymentType}
                  paymentLink={paymentLink}
                />
              )}
            </>
          </div>
        </>
      ) : (
        <div />
      )}
      <Footer />
    </div>
  );
};
export default PaymentLink;
